const updateContests = (payload) => {
  return {
    type: 'contests/update',
    payload
  }
}

export default updateContests;